import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  DROPDOWN: `${cleanedFilename(__filename)}-dropdown`,
  OPTIONS: `${cleanedFilename(__filename)}-options`,
};
